<guideline-sidebar-anchor-link [links]="links()" (linksChanged)="onLinksChanged($event)" />

<guideline-sidebar-references [references]="references()" (referencesChanged)="onReferencesChanged($event)" />

<tt-sidebar-attachments [attachments]="attachments()" (attachmentsChange)="onAttachmentsChanged($event)" />

<tt-sidebar-resource-tags [selectedTags]="resourceTags() ?? []" (selectedTagsChange)="onTagsChanged($event)" />
